export const changeCurrencyFormat = (
  exchangeRate: number,
  moneySign: '€' | '$',
  amount: number
) => {
  const transformedAmount = `${moneySign} ${amount * exchangeRate}`;
  return transformedAmount;
};
